import { axiosInstance } from "./api";

export const getMoving = async ({
  paginationCount,
  paginationOffset,
  search,
  number,
  admin,
}) => {
  const params = {
    count: paginationCount,
    offset: paginationOffset,
    search,
    number,
    admin,
  };

  const res = await axiosInstance.get("/api/v2/moving", { params });
  return res.data;
};

export const getMovingOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/moving/${id}`);
  return res.data;
};

export const createMoving = async (props) => {
  const res = await axiosInstance.post("/api/v2/moving", props);
  return res.data;
};

export const updateMoving = async (props) => {
  const res = await axiosInstance.patch(`/api/v2/moving/${props.id}`, props);
  return res.data;
};

export const carryOutMoving = async (props) => {
  const res = await axiosInstance.post("/api/v2/moving/carryOut", props);
  return res.data;
};

export const updateMovingProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/moving/updateProduct", props);
  return res.data;
};

export const removeMovingProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/moving/removeProduct", props);
  return res.data;
};

export const getStock = async (params) => {
  const res = await axiosInstance.get("/stock.get", { params });
  return res.data;
};

export const getStockByWarehouse = async (params) => {
  const res = await axiosInstance.get("/stock.getByWarehouse", { params });
  return res.data;
};

export const updatePriceByStock = async (props) => {
  const res = await axiosInstance.post("/stock.updatePriceByStock", props);
  return res.data;
};

export const getSupplyProductsByNomenclature = async (params) => {
  const res = await axiosInstance.get(
    "/stock.getSupplyProductsByNomenclature",
    { params }
  );
  return res.data;
};

export const updateStock = async (props) => {
  const res = await axiosInstance.post("stock.update", props);
  return res.data;
};

export const getRelatedDocuments = async (params) => {
  const res = await axiosInstance.get("/stock.getRelatedDocuments", { params });
  return res.data;
};

export const removerStock = async (props) => {
  const res = await axiosInstance.post("/stock.remove", props);
  return res.data;
};

export const getWarehouses = async (params) => {
  const res = await axiosInstance.get("/warehouses.get", { params });
  return res.data;
};

export const getWriteOffs = async ({
  paginationCount,
  paginationOffset,
  search,
  number,
  admin,
}) => {
  const params = {
    count: paginationCount,
    offset: paginationOffset,
    search,
    number,
    admin,
  };

  const res = await axiosInstance.get("/api/v2/writeOff", { params });
  return res.data;
};

export const getWriteOffOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/writeOff/${id}`);
  return res.data;
};

export const createWriteOff = async (props) => {
  const res = await axiosInstance.post("/api/v2/writeOff", props);
  return res.data;
};

export const carryOutWriteOff = async (props) => {
  const res = await axiosInstance.post("/api/v2/writeOff/carryOut", props);
  return res.data;
};

export const updateWriteOffProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/writeOff/updateProduct", props);
  return res.data;
};

export const getMisgradings = async ({
  paginationCount,
  paginationOffset,
  search,
  number,
  admin,
}) => {
  const params = {
    count: paginationCount,
    offset: paginationOffset,
    search,
    number,
    admin,
  };

  const res = await axiosInstance.get("/api/v2/misgrading", { params });
  return res.data;
};

export const getMisgradingOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/misgrading/${id}`);
  return res.data;
};

export const createMisgrading = async (props) => {
  const res = await axiosInstance.post("/api/v2/misgrading", props);
  return res.data;
};

export const carryOutMisgrading = async (props) => {
  const res = await axiosInstance.post("/api/v2/misgrading/carryOut", props);
  return res.data;
};

export const updateMisgradingProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/misgrading/updateProduct", props);
  return res.data;
};

export const removeMisgradingProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/misgrading/removeProduct", props);
  return res.data;
};
